/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- <el-button @click="show = !show">Click Me</el-button> -->

    <div
      style="
        display: flex;
        font-size: 25px;
        height: 50px;
        color: #919191;
        font-family: cursive;
      "
    >
      <transition name="el-fade-in-linear">
        <i v-show="show" @click="back" class="el-icon-back"></i>
      </transition>
      <transition name="el-fade-in-linear">
        <div style="margin-left: 10px" v-show="show" class="transition-box">
          编辑文章
        </div>
      </transition>
    </div>
    <div>
      <el-form
        :label-position="'right'"
        label-width="80px"
        :model="formDataAdd"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题">
              <el-input v-model="formDataAdd.newsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="文章Id">
              <el-input v-model="formDataAdd.newsId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跳转路径">
              <el-input v-model="formDataAdd.url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发布时间">
              <!-- <el-input v-model="formDataAdd.releaseTime"></el-input> -->
              <el-date-picker
                class="dataPicker"
                @change="changeTime"
                v-model="formDataAdd.time"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="文章内容">
          <!-- <el-input type="textarea" class="content" v-model="formDataAdd.content"></el-input> -->
          <quill-editor
            class="ql-editor"
            v-model="formDataAdd.content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
          >
          </quill-editor>
          <el-upload
            style="display: none"
            class="quill-picture-uploader"
            :action="imgsUploadUrl"
            :before-upload="bfUpload"
            :on-success="uploadSuccess"
          >
          </el-upload>
        </el-form-item>
      </el-form>

      <el-row style="text-align: right">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="commit">提交</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCompanyList, editTbArticleList } from "../../api/newApis";
import { API_BASE } from "@/config/apiBase";
import Quill from "quill";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { ImageDrop } from "quill-image-drop-module"; // 图片拖动组件引用
import ImageResize from "quill-image-resize-module"; // 图片缩放组件引用
Quill.register("modules/imageDrop", ImageDrop); // 注册
Quill.register("modules/imageResize", ImageResize); // 注册
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
  ["blockquote", "code-block"], //引用，代码块
  [{ header: 1 }, { header: 2 }], // 几级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序列表，无序列表
  [{ script: "sub" }, { script: "super" }], // 下角标，上角标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ direction: "rtl" }], // 文字输入方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 颜色选择
  [{ font: [] }], // 字体
  [{ align: [] }], // 居中
  ["clean"], // 清除样式,
  ["link", "image"], // 上传图片、上传视频
];

export default {
  computed: {
    imgsUploadUrl() {
      return `${API_BASE}/imgs`;
    },
  },
  data() {
    return {
      urlList: [],
      // 富文本编辑器默认内容
      content: "",
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请在这里输入",
        theme: "snow", //主题 snow：有工具栏的；bubble：只有文本域的
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false,
        },
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
          toolbar: {
            container: toolbarOptions, //工具栏
            handlers: {
              image: function (value) {
                //替换原图片上传功能
                if (value) {
                  document
                    .querySelector(".quill-picture-uploader input")
                    .click(); //核心
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      show: false,
      formDataAdd: {
        title: "",
        author: "",
        content: "",
        imgs: "",
        releaseTime: "",
        art_read: "",
        ups: "",
        states: "",
        name_id: "",
      },
      nameArr: [],
      stateList: [
        {
          contentName: "草稿",
          states: 0,
        },
        {
          contentName: "发布",
          states: 1,
        },
      ],
      conpmanyOptions: null,
    };
  },
  // 注册组件
  components: {
    quillEditor,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getCompant();
    const editData = JSON.parse(localStorage.getItem("editData"));
    // editData.name_id = Number(editData.name_id)
    console.log(editData.name_id);
    // var array = new Array();
    // var newArray = [];
    /*     if (editData.name_id.includes(",")) {
      array = editData.name_id.split(",");
      array.map((item, index) => {
        item = Number(item);
        newArray.push(item);
      });
      editData.name_id = newArray;
      this.formDataAdd = editData;
    } else {
      editData.name_id = Number(editData.name_id);
      // console.log(2222,editData.name_id);
      console.log(newArray);
      newArray.push(editData.name_id);
      console.log(1111, newArray);
      editData.name_id = newArray;
      this.formDataAdd = editData;
    } */

    this.formDataAdd = editData;

    setTimeout(() => {
      this.show = !this.show;
    }, 500);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleAvatarSuccess1(file) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // console.log(file);
      this.formDataAdd.cover_picture = file.data;
      setTimeout(() => {
        loading.close();
      }, 2000);
    },

    //上传图片之前校验
    bfUpload(file) {
      console.log(file);
      if (
        "image/png" == file.type ||
        "image/jpeg" == file.type ||
        "image/jpg" == file.type ||
        "image/gif" == file.type
      ) {
      } else {
        this.$message.error("图片插入失败,请检查文件格式");
        return;
      }
    },
    //正文插入图片上传成功调用
    uploadSuccess(response, file, fileList) {
      console.log("response", response);
      this.urlList.push(response.data);
      let quill = this.$refs.myQuillEditor.quill;
      if (response.data != null) {
        console.log("quill.getSelection()", quill.getSelection());
        //获取光标所在位置
        let length = quill.getSelection().index;
        //插入图片
        quill.insertEmbed(length, "image", response.data);
        //移动光标到图片后
        quill.setSelection(length + 1);
      }
    },
    // 失去焦点事件
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    async getCompant() {
      const res = await getCompanyList();
      this.conpmanyOptions = res.data;
      // console.log(res);
    },
    changeState(val) {
      console.log(8888888888, val);
      this.formDataAdd.states = val;
      // console.log(val);
    },
    back() {
      this.$router.go(-1);
    },

    async commit() {
      // debugger
      // const result = this.formDataAdd.name_id.join(",");
      // this.formDataAdd.name_id = result;
      // console.log(1222222222, this.formDataAdd.states);
      // this.nameArr = result

      // console.log(4444,this.formDataAdd.name_id);
      // console.log(this.formDataAdd);

      if (this.formDataAdd.newsName == "") {
        this.$message.error("文章标题不能为空哦！");
        return;
      }
      if (this.formDataAdd.newsId == "") {
        this.$message.error("文章Id不能为空哦！");
        return;
      }

      if (this.formDataAdd.time == "") {
        this.$message.error("发布时间不能为空哦！");
        return;
      }
      if (this.formDataAdd.url == "") {
        this.$message.error("跳转路径不能为空哦！");
        return;
      }

      // this.formDataAdd.name_id = this.nameArr
      let res = await editTbArticleList(this.formDataAdd);
      if (res.code == 200) {
        this.$message.success("修改成功");
        setTimeout(() => {
          this.$router.push("/CPIC/articleList");
        }, 500);
      }
      console.log(res);
    },

    cancel() {
      this.$router.push("/CPIC/articleList");
    },

    changeTime(val) {
      const time = this.newDate(val);
      this.formDataAdd.releaseTime = time;
    },

    newDate(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
  },
};
</script>

<style scoped>
/deep/ .company .el-input--suffix .el-input__inner {
  width: 1000px;
}
/deep/ .ql-container {
  height: 600px;
}

.state {
  width: 460px !important;
}

/deep/ .content .el-textarea__inner {
  min-height: 400px !important;
}

.dataPicker {
  width: 460px !important;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/CPIC/editArticle.vue